module.exports = __webpack_public_path__ + "img/f909a35.jpg";